import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getContainerImagesQueryKey } from 'hooks/queries/security-insights/useContainerImagesQuery';

export const useDeleteImagesMutation = (
  onSuccess?: () => void
): UseMutationResult<unknown, unknown, string[], unknown> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (tagNames) => {
      return apiClient.securityInsights.deleteImages({ body: { tagNames } });
    },
    onSuccess: (_, tagNames) => {
      notify.success(
        `${
          tagNames.length === 1 ? 'Repository was' : 'Repositories were'
        } removed!`
      );
      queryClient.resetQueries({
        queryKey: getContainerImagesQueryKey(),
      });
      onSuccess?.();
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
